import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { StepForm } from './getStepForm';

export type UpdateStepFormOptions = {
   fields: Array<{
      field_type: string;
      label: string;
      field_guid: string;
      placeholder?: string | boolean;
      textarea?: string;
      required?: boolean;
      options?: any;
   }>;
};

export async function updateStepForm(
   stepId: number,
   stepForm: UpdateStepFormOptions,
   common: CommonRequestOptions = {}
): Promise<StepForm> {
   return makeRequest('post', `/step_forms/${stepId}`, {
      ...common,
      body: stepForm,
   });
}
